export const faqs = [
  {
    question: '麻将游戏在线玩需要下载吗？',
    answer: '不需要！我们的麻将游戏全部支持在线即开即玩，无需下载任何软件或APP。只需要打开浏览器，就能立刻开始麻将游戏。支持电脑和手机浏览器，真正做到随时随地畅玩麻将。',
  },
  {
    question: '在线麻将支持哪些玩法？',
    answer: '我们提供丰富的麻将玩法选择，包括经典麻将、四川麻将（血战到底）、广东麻将（推倒胡）、上海麻将（清混碰）、台湾十六张麻将、香港麻将、日本立直麻将等。还有单机AI对战模式，满足不同玩家的需求。',
  },
  {
    question: '在线麻将游戏免费吗？',
    answer: '是的，所有麻将游戏完全免费！无需付费即可享受完整的麻将游戏体验。我们致力于让更多人能够轻松享受麻将的乐趣，没有任何隐藏收费。',
  },
  {
    question: '手机可以在线玩麻将吗？',
    answer: '当然可以！我们的麻将游戏完美适配手机浏览器，无论是iPhone还是Android手机，都能流畅运行。触屏操作经过专门优化，在手机上打麻将的体验非常出色。',
  },
  {
    question: '新手不会玩麻将怎么办？',
    answer: '完全不用担心！我们提供详细的新手教程和游戏指南，从最基础的牌型识别到高级策略技巧，应有尽有。还有单机AI练习模式，让新手可以在无压力环境下练习。大多数新手经过几局练习就能掌握基本玩法。',
  },
  {
    question: '在线麻将可以和真人玩家对战吗？',
    answer: '支持！我们提供真人在线匹配对战功能，系统会根据你的水平自动匹配实力相近的对手，保证每局比赛的公平性和趣味性。也支持邀请好友一起加入房间对战。',
  },
  {
    question: '四川麻将和普通麻将有什么不同？',
    answer: '四川麻将最大的特色是"血战到底"规则：一家胡牌后，其余三家继续对战直到只剩最后一家。还有"缺一门"规则（必须缺一种花色）、"刮风下雨"（杠牌得分）等独特规则，让游戏更加刺激有趣。',
  },
];

export const siteFeatures = [
  {
    icon: 'ri-flashlight-line',
    title: '即开即玩',
    description: '无需下载安装，打开浏览器就能立刻开始麻将游戏，方便快捷',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端支持',
    description: '完美适配电脑和手机，随时随地畅享麻将乐趣',
  },
  {
    icon: 'ri-gamepad-line',
    title: '多种玩法',
    description: '经典麻将、四川麻将、广东麻将等十几种玩法任你选择',
  },
  {
    icon: 'ri-shield-check-line',
    title: '公平竞技',
    description: '智能匹配系统确保公平对局，让每场比赛都充满悬念',
  },
  {
    icon: 'ri-user-heart-line',
    title: '新手友好',
    description: '详细教程和AI练习模式，让零基础玩家也能快速上手',
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: '完全免费',
    description: '所有游戏功能完全免费，没有任何隐藏收费项目',
  },
];